import moment, { Moment } from 'moment'

import { FILTER_DATE_FORMAT, RANGE_TYPES } from 'lib/GlobalConstants'
import { CustomDateRange } from 'types/ReportingDashboardFilter'

export const formatDate = (date: Date | Moment | undefined, format: string) => {
  return moment(date).format(format)
}

export const getDateRange = (
  type: string,
  shouldConvert = false,
  createdAt?: string,
) => {
  let startDate: any
  switch (type) {
    case RANGE_TYPES.week:
      startDate = moment().subtract(6, 'days')
      break
    case RANGE_TYPES.month:
      startDate = moment().subtract(29, 'days')
      break
    case RANGE_TYPES.allTime:
      startDate = createdAt ? moment(new Date(createdAt)) : moment()
      break
  }

  if (shouldConvert)
    return {
      startDate: startDate?.toDate(),
      endDate: moment()?.toDate(),
      key: 'selection',
    }

  return {
    startDate,
    endDate: moment(),
    key: 'selection',
    dateRangeOption: type,
  }
}

// It calculates and formats date range based on given type
export const calculateDateRange = (
  rangeType: string,
  customDateRange?: CustomDateRange,
) => {
  const isCustomDateRange = rangeType === RANGE_TYPES.custom && customDateRange
  const dateRange = isCustomDateRange
    ? customDateRange
    : getDateRange(rangeType)

  const formattedStartDate = formatDate(dateRange.startDate, FILTER_DATE_FORMAT)
  const formattedEndDate = formatDate(dateRange.endDate, FILTER_DATE_FORMAT)

  return `${formattedStartDate} - ${formattedEndDate}`
}

export const getYears = () => {
  const endYear = new Date().getFullYear() + 150
  const years = []
  let startYear = new Date().getFullYear() - 150
  while (startYear <= endYear) {
    years.push(startYear++)
  }
  return years
}
